import { UseCase } from '../../shared/use-case';
import { AddToCartUsecaseRequest } from './add-to-cart-usecase-request';
import { Void } from '../../shared/void';
import { ValidationError } from '../../shared/validation.error';
import { Material } from '../material';
import { Injectable } from '@angular/core';
import { LogService } from '../../shared/log.service';
import { TranslationConfig } from '../../translation/translation-config';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AddToCartUsecase extends UseCase<AddToCartUsecaseRequest, Void> {
    constructor(_logService: LogService, _httpClient: HttpClient, _translationConfig: TranslationConfig) {
        super(_logService, _httpClient, _translationConfig.enableUseCaseStatusLogs);
    }
    protected override validate(request: AddToCartUsecaseRequest) {
        if (!request.material) {
            new ValidationError('Material cannot be added to shopping cart!');
        }
    }
    protected override executeBusinessLogic(request: AddToCartUsecaseRequest): void {
        this._logService.info('Material from /book arrived: ' + request.material);
        const materials = request.materials as Material[];
        let counter = 0;
        materials.forEach((material) => {

            if(request?.material?.id == material.id && request?.material?.packageName === material.packageName ) {
                request?.material == material;
                material.quantity!++;
                material.quantityOfSupply!--;
                counter++;
            }


        });

        if (counter == 0) {
            if (request.material?.quantity == 0) {
                request.material.quantity++;
                request.material.quantityOfSupply!--;
                materials.push(request.material as Material);


            }
        }
        this.storeMaterialInSession(materials);
    }

    storeMaterialInSession(materials:Material[]) {
    if(sessionStorage.getItem('materials')) {
       sessionStorage.removeItem('materials');
       sessionStorage.setItem('materials', JSON.stringify(materials));
    }
    else {
        sessionStorage.setItem('materials', JSON.stringify(materials));
    }


    }
}
